import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useIntl } from 'react-intl';
import messages from '../readinessMessages';
const badges = {
    ok: { className: 'label readiness-badge ok', message: messages.OkLabel },
    warning: { className: 'label readiness-badge warning', message: messages.WarningBadge },
    issue: { className: 'label readiness-badge issue', message: messages.AttentionBadge },
};
const StatusBadge = ({ state }) => {
    const intl = useIntl();
    return (_jsx("span", Object.assign({ className: badges[state].className }, { children: intl.formatMessage(badges[state].message) })));
};
export default StatusBadge;
